import { DefaultInMemoryPagingOfferConfiguration } from './DefaultInMemoryPagingOfferConfiguration';
import { ILiveUpcomingPageableOfferConfiguration } from "./ILiveUpcomingPageableOfferConfiguration";

export class DefaultLiveUpcomingPageableConfiguration extends DefaultInMemoryPagingOfferConfiguration implements ILiveUpcomingPageableOfferConfiguration {
}